async function deleteReservation(API_BASE, token, id) {
    const headers = {
        "Authorization": `Bearer ${token}`,
    };

    const res = await fetch(`${API_BASE}/reservations/${id}`, {
        method: "DELETE",
        headers,
    });

    if (!res.ok) {
        throw new Error(await res.text());
    }

    return true;
}
export default deleteReservation;
